/* eslint-disable prettier/prettier */
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import moment from 'moment';
import { db } from 'firebase/fbConfig.js';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from "@material-ui/core/Slide";

import Style from "assets/jss/material-dashboard-pro-react/views/actionsStyle";

// Firebase Redux Integration
import TripBuilder from "./TripBuilder";

import { formatOrders } from 'tables/rows/orders';

const Transition = (props) => {
    return <Slide direction="down" {...props} />
}

const Principles = props => {
    const [loaded, setLoaded] = useState(false);
    const [selectedOrders, setSelectedOrders] = useState();

    const rowFromOrder = (id) => new Promise((resolve, reject) => {

        db.collection('haney-orders').doc(id).get()
            .then(snap => formatOrders({ docs: [snap]}))
            .then(data => resolve(data))
            .catch(err => reject(err));
    })

    const getOrders = async (orderIDs) => {
        const orders = await Promise.all(orderIDs.map(id => rowFromOrder(id)))
        setSelectedOrders(orders.flat());
        setLoaded(true);
    }

    useEffect(() => {

        const [a, b, c, ...orderIDs] = window.location.pathname.split('/')

        if (orderIDs.length) {
            getOrders(orderIDs);
        } else {
            setLoaded(true);
        }

    }, []);

    return loaded && props.authUser ? (
        <TripBuilder
            selectedOrders={selectedOrders}
            authUser={props.authUser}
            trip={props.trip}
            tripID={props.tripID}
        />
    ) : <p>Loading...</p>;
}

const mapStateToProps = (state) => {
    console.log(state)
    return {
        authUser: state.auth.user,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    // console.log(ownProps)
    return {
        // startSetAllOrdersList: dispatch(startSetTripOrdersList(ownProps))
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(Style)
)(Principles);


// WEBPACK FOOTER //
// ./src/views/Trips/TripBuilderParent.jsx